'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />

            <TechHero
                className=""
                desc="Leverage The Power of Full-Stack JavaScript Development to Build Robust, Dynamic Yet Scalable Web Applications."
                alt="Full Stack Development"
                title="Full Stack Development"
                width={1090}
                height={604}
                path={'fullstack-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                Full Stack<div>Development Company</div>
            </TechHero>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Full Stack" />
            <ContetVideoSection title="Our Comprehensive Expertise as a Leading Full Stack Development Company">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Whatever may be the size of your business, our full-stack JavaScript developers are all prepared to help
                        you build secured and optimized applications in compliance with the latest market standards. Before
                        getting inside the development process, we gauge your requirements; identify the client and server-side
                        responsibilities, and then kick-start with the application development. We house a pool of skilled and
                        agile full-stack developers who have wide experience in switching roles between front-end as well back-end
                        development to deliver robust, quick, and arduous end-to-end solutions to all B2B and B2C clients
                        globally.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">So, what are you waiting for?</p>
                </>
            </ContetVideoSection>
            <HireProcess
                bg="bg-fullstack"
                pageTitle="Hire Full Stack Developers To Build Cutting-Edge Digital Products"
                desc="Our full-stack developers are experts in switching roles between front-end and back-end to ensure you get the best of both, either for web, mobile, or desktop applications."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For Full Stack Development?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best Full-Stack Developers"
                desc="Select from different engagement models to hire Full Stack Developers for your business needs. Different types of engagements allow you to find an optimal match for your company's specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
